<mat-card class="view-detail-branch">
    <mat-card-header>
        <mat-card-title>{{'title.view_info_branch' | translate}} {{oldBranchName}}
        </mat-card-title>
    </mat-card-header>

    <mat-card-content>
        <mat-accordion #accordion="matAccordion" [multi]="true">
            <mat-expansion-panel expanded="true">
                <mat-expansion-panel-header>
                    <mat-panel-title class="mat-panel-title">
                        {{'title.enterprise_info' | translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row" #focus tabindex="-1">
                    <label class="col-sm-2 col-form-label text-right font-weight-bold">{{'search_form.username' |
                        translate}}</label>
                    <label class="col-sm-4 col-form-label">
                        {{branch.adminUser}}
                    </label>
                    <label class="col-sm-2 col-form-label text-right font-weight-bold">{{'form.branch_name' |
                        translate}}</label>
                    <div class="col-sm-4 col-form-label">
                        {{branch.name}}
                    </div>
                    <label class="col-sm-2 col-form-label text-right font-weight-bold">{{'search_form.enterprise_type' |
                        translate}}</label>
                    <label class="col-sm-4 col-form-label">
                        {{getEnterpriseTypeOptions(type)}}
                    </label>
                    <label class="col-sm-2 col-form-label text-right font-weight-bold">{{'search_form.status' |
                        translate}}</label>
                    <div class="col-sm-4 col-form-label">
                        {{branch.status ? 'Hoạt động' : 'Ngừng hoạt động'}}
                    </div>
                    <label class="col-sm-2 col-form-label text-right font-weight-bold">{{'form.type_certification' |
                        translate}}</label>
                    <label class="col-sm-4 col-form-label">
                        {{getEnterpriseTypeOptions(certificate)}}
                    </label>
                    <label class="col-sm-2 col-form-label text-right font-weight-bold">{{'form.gpkd' |
                        translate}}</label>
                    <div class="col-sm-4 col-form-label">
                        {{branch.certificateNo}}
                    </div>
                    <label class="col-sm-2 col-form-label text-right font-weight-bold">{{'form.issued_by' |
                        translate}}</label>
                    <label class="col-sm-4 col-form-label">
                        {{branch.issuedAt}}
                    </label>
                    <label class="col-sm-2 col-form-label text-right font-weight-bold">{{'form.issued_date' |
                        translate}}</label>
                    <div class="col-sm-4 col-form-label">
                        {{branch.issuedDate}}
                    </div>
                    <label class="col-sm-2 col-form-label text-right font-weight-bold">{{'form.tax_code' |
                        translate}}</label>
                    <div class="col-sm-4 col-form-label">
                        {{branch.taxCode}}
                    </div>
                </div>
            </mat-expansion-panel>
            <mat-expansion-panel expanded="true">
                <mat-expansion-panel-header>
                    <mat-panel-title class="mat-panel-title">
                        {{'title.representative_info' | translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row" #focus tabindex="-1">
                    <label class="col-sm-2 col-form-label text-right font-weight-bold">{{'form.fullname' |
                        translate}}</label>
                    <label class="col-sm-4 col-form-label">
                        {{branch.representative}}
                    </label>
                    <label class="col-sm-2 col-form-label text-right font-weight-bold">{{'form.position' |
                        translate}}</label>
                    <div class="col-sm-4 col-form-label">
                        {{branch.position}}
                    </div>
                    <label class="col-sm-2 col-form-label text-right font-weight-bold">{{'form.type' |
                        translate}}</label>
                    <label class="col-sm-4 col-form-label">
                        {{getEnterpriseTypeOptions(representativeCertificateName)}}
                    </label>
                    <label class="col-sm-2 col-form-label text-right font-weight-bold">{{'form.certification_no' |
                        translate}}</label>
                    <div class="col-sm-4 col-form-label">
                        {{branch.representativeCertificateNo}}
                    </div>
                    <label class="col-sm-2 col-form-label text-right font-weight-bold">{{'form.issued_date' |
                        translate}}</label>
                    <label class="col-sm-4 col-form-label">
                        {{branch.representativeIssuedDate}}
                    </label>
                    <label class="col-sm-2 col-form-label text-right font-weight-bold">{{'form.issued_by' |
                        translate}}</label>
                    <div class="col-sm-4 col-form-label">
                        {{branch.representativeIssuedOn}}
                    </div>
                    <label class="col-sm-2 col-form-label text-right font-weight-bold">{{'form.birthday' |
                        translate}}</label>
                    <label class="col-sm-4 col-form-label">
                        {{branch.birthday}}
                    </label>
                    <label class="col-sm-2 col-form-label text-right font-weight-bold">{{'form.sex' |
                        translate}}</label>
                    <div class="col-sm-4 col-form-label">
                        {{branch.sex ? 'Nam' : 'Nữ'}}
                    </div>
                </div>
            </mat-expansion-panel>
            <mat-expansion-panel expanded="true">
                <mat-expansion-panel-header>
                    <mat-panel-title class="mat-panel-title">
                        {{'title.address' | translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row" #focus tabindex="-1">
                    <label class="col-sm-2 col-form-label text-right font-weight-bold">{{'form.city' |
                        translate}}</label>
                    <label class="col-sm-4 col-form-label">
                        {{cityName}}
                    </label>
                    <label class="col-sm-2 col-form-label text-right font-weight-bold">{{'form.district' |
                        translate}}</label>
                    <div class="col-sm-4 col-form-label">
                        {{districtName}}
                    </div>
                    <label class="col-sm-2 col-form-label text-right font-weight-bold">{{'form.ward' |
                        translate}}</label>
                    <label class="col-sm-4 col-form-label">
                        {{wardName}}
                    </label>
                    <label class="col-sm-2 col-form-label text-right font-weight-bold">{{'form.address' |
                        translate}}</label>
                    <div class="col-sm-4 col-form-label">
                        {{branch.addresses[0].address}}
                    </div>
                    <label class="col-sm-2 col-form-label text-right font-weight-bold">{{'form.email' |
                        translate}}</label>
                    <label class="col-sm-4 col-form-label">
                        {{branch.email}}
                    </label>
                    <label class="col-sm-2 col-form-label text-right font-weight-bold">{{'form.phone' |
                        translate}}</label>
                    <div class="col-sm-4 col-form-label">
                        {{branch.phone}}
                    </div>
                    <label class="col-sm-2 col-form-label text-right font-weight-bold">{{'form.fax' |
                        translate}}</label>
                    <div class="col-sm-4 col-form-label">
                        {{branch.fax}}
                    </div>
                </div>
            </mat-expansion-panel>
            <mat-expansion-panel expanded="true">
                <mat-expansion-panel-header>
                    <mat-panel-title class="mat-panel-title">
                        {{'title.address' | translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row" #focus tabindex="-1">
                    <label class="col-sm-2 col-form-label text-right font-weight-bold">{{'form.bank' |
                        translate}}</label>
                    <label class="col-sm-4 col-form-label">
                        {{branch.bankName}}
                    </label>
                    <label class="col-sm-2 col-form-label text-right font-weight-bold">{{'form.accnumber' |
                        translate}}</label>
                    <div class="col-sm-4 col-form-label">
                        {{branch.accountNumber}}
                    </div>
                    <label class="col-sm-2 col-form-label text-right font-weight-bold">{{'form.branch' |
                        translate}}</label>
                    <label class="col-sm-4 col-form-label">
                        {{branch.bankBranch}}
                    </label>
                </div>
            </mat-expansion-panel>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title class="mat-panel-title">
                        {{'title.attach' | translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="pb-3">
                    <app-upload-multi-file [isViewDetail]="true" [arrAttachments]="branch.attachments">
                    </app-upload-multi-file>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </mat-card-content>

    <!-- Lưu  -->
    <mat-card-actions class="text-center">
        <button (click)="onBack()" mat-raised-button type="button" color="primary">
            <mat-icon class="mr-0">arrow_back</mat-icon>{{ 'button.back' | translate }}
        </button>
    </mat-card-actions>
</mat-card>


